import { SearchTable } from './SearchTable';
import { useCovaloColumns } from './columns/CovaloColumns';
import { SearchDocument } from 'types/Search';
import { MRT_Row } from 'material-react-table';
import { SearchViewPropsExtended } from './types';
import { SegmentTag } from 'types/global';
type SearchTableProps<T extends object> = {
  setShowRegisterModal: (a: boolean) => void;
} & SearchViewPropsExtended<T>;

export const CovaloTable: React.FC<
  SearchTableProps<SearchDocument>
> = props => {
  const columns = useCovaloColumns(
    props.searchResults.search?.segment === SegmentTag.FOOD,
    props.target
  );

  const generateProductPageLink = (row: MRT_Row<SearchDocument>) => {
    return `/${props.searchResults.search?.target.toLowerCase()}/permalink/${
      row.original.old_key
    }`;
  };

  return (
    <SearchTable<SearchDocument>
      {...props}
      getRowId={row => row.id}
      columns={columns}
      enableMarketingBanner
      generateItemPageLink={generateProductPageLink}
    />
  );
};
